import React, { useMemo } from 'react';
import classNames from 'classnames';

import BuoySwell from '../BuoySwell';

import type { Swell } from '../../types/swell';
import { SurfHeight } from '../../types/units';

import styles from './BuoySwells.module.scss';

const getClass = (offline: boolean, largeOnly: boolean) =>
  classNames({
    [styles.buoySwells]: true,
    [styles.buoySwellsLargeOnly]: largeOnly,
    [styles.buoySwellsOffline]: offline,
  });

interface Props {
  swells?: Swell[];
  units: SurfHeight;
  largeOnly?: boolean;
  offline?: boolean;
}

const swellImpact = (swell: Swell) =>
  swell.period && swell.height ? swell.height * (0.1 * swell.period) : 0;

export const getTop3Swells = (swells: Swell[]) =>
  [...swells]
    .filter((swell) => swell.height && swell.height > 0 && swell.period && swell.period > 0)
    .map((swell) => ({ ...swell, impact: swellImpact(swell) }))
    .sort((a, b) => a.impact - b.impact)
    .reverse()
    .slice(0, 3);

const BuoySwells: React.FC<Props> = ({
  units,
  largeOnly = false,
  offline = false,
  swells = [],
}) => {
  const top3Swells = useMemo(() => getTop3Swells(swells), [swells]);

  if (offline && !largeOnly) {
    return null;
  }

  return (
    <div>
      {largeOnly && <h2 className={styles.buoySwellsTitle}>Individual Swells</h2>}
      <ul className={getClass(offline, largeOnly)}>
        {!offline
          ? top3Swells.map((swell) => (
              <li
                className={styles.buoySwellsItem}
                key={`${swell.height}-${swell.period}-${swell.direction}`}
              >
                <BuoySwell
                  height={swell.height}
                  period={swell.period}
                  direction={swell.direction}
                  units={units}
                />
              </li>
            ))
          : ['No Data', '-', '-'].map((text, i) => (
              <li className={styles.buoySwellsOfflineItem} key={`${text}-${i}`}>
                <p>{text}</p>
              </li>
            ))}
      </ul>
    </div>
  );
};

export default BuoySwells;
